import { render, staticRenderFns } from "./unsubscribe.vue?vue&type=template&id=cf2f2474"
import script from "./unsubscribe.vue?vue&type=script&lang=js"
export * from "./unsubscribe.vue?vue&type=script&lang=js"
import style0 from "./unsubscribe.vue?vue&type=style&index=0&id=cf2f2474&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports